<template>
  <div class="justify-self-start p-3 text-body-1 flex items-center flex-wrap gap-1">
    <template v-if="systolicPressure.hasMeasurement">
      {{ systolicPressure.displayValue }}
      <span class="text-xs">{{ isInvasive ? 'IBP' : 'NIBP' }}</span>
    </template>

    <template v-else>
      <span class="w-full text-center block">–</span>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { SystolicPressureVitalsElement } from '../../composables/usePatientVitals'

const { systolicPressure = { hasMeasurement: false, displayValue: '', isInvasive: false } } =
  defineProps<{
    systolicPressure: SystolicPressureVitalsElement
    isInvasive: boolean
  }>()
</script>
